import { IUniqueId, IUniqueIdPDTO } from "../models/_uniqueId";
import { IReservationPDTO } from "../models/dtos/reservationPDTO";
import { IFilter } from "../models/filters/filter";
import { IReservationFilter } from "../models/filters/reservationFilter";
import { IReservationForm } from "../models/forms/reservationForm";
import _o2sService from "./_o2sServices";
import { API_CENTRE } from "./config";

export default class ReservationService extends _o2sService {
    
    protected static override mainUrl: string = API_CENTRE + "/api/v1/reservations";

    protected static override getUrlFilter<F extends IReservationFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);

        if(filter != null) {

            if(filter.id != null)
                url += `&ReservationId=${filter.id}`

            if(filter.animalId != null)
                url += `&AnimalId=${filter.animalId}`

            if(filter.reasonId != null)
                url += `&ReasonId=${filter.reasonId}`

            if(filter.reasonCode != null)
                url += `&ReasonCode=${filter.reasonCode}`

            if(filter.issueDate != null)
                url += `&IssueDate=${filter.issueDate}`

            if(filter.issueDateFrom != null)
                url += `&IssueDateFrom=${filter.issueDateFrom.toISOString()}`

            if(filter.centerId != null)
                url += `&CenterId=${filter.centerId}`

            if(filter.includeRemoved != null)
                url += `&IncludeRemoved=${filter.includeRemoved}`
            else
                url += `&IncludeRemoved=false`
        }

        return url;
    }

    protected static override toDTO(obj: IReservationForm): IReservationPDTO {
        const dto = super.toDTO(obj) as IReservationPDTO;

        return dto;
    }
}